/**
 * Formula configuration utilities
 */

interface FormulaConfig {
  hideDiscounts?: boolean;
  hideCategoryDiamonds?: boolean;
  hideSalesOnDeals?: boolean;
  mediaCdn?: string;
  imagesCdn?: string;
  hideHotelFilters?: boolean;
  hideRestaurantFilters?: boolean;
  hideAvailabilitySearch?: boolean;
}

declare global {
  interface Window {
    FORMULA_CONFIG?: FormulaConfig;
  }
}

/**
 * Check if discounts should be hidden based on formula settings
 */
export function hideDiscounts(): boolean {
  return window.FORMULA_CONFIG?.hideDiscounts === true;
}

/**
 * Check if category diamonds should be hidden based on formula settings
 */
export function hideCategoryDiamonds(): boolean {
  return window.FORMULA_CONFIG?.hideCategoryDiamonds === true;
}

/**
 * Check if sales should be hidden on deals based on formula settings
 */
export function hideSalesOnDeals(): boolean {
  return window.FORMULA_CONFIG?.hideSalesOnDeals === true;
}

export function mediaCdn(): string {
    return window.FORMULA_CONFIG?.mediaCdn ?? '';
}

export function imagesCdn(): string {
    return window.FORMULA_CONFIG?.imagesCdn ?? '';
}

/**
 * Check if hotel filters should be hidden based on formula settings
 */
export function hideHotelFilters(): boolean {
  return window.FORMULA_CONFIG?.hideHotelFilters === true;
}

/**
 * Check if restaurant filters should be hidden based on formula settings
 */
export function hideRestaurantFilters(): boolean {
  return window.FORMULA_CONFIG?.hideRestaurantFilters === true;
}

/**
 * Check if availability / date-search surfaces should be hidden based on formula settings
 */
export function hideAvailabilitySearch(): boolean {
  return window.FORMULA_CONFIG?.hideAvailabilitySearch === true;
}
